import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sedancabservicweforcorporateemployees() {



  const cardData =
  {
    keyword: ' Sedan Cab Service for Corporate Employees Pune',
    heading: 'Pune Corporate Cars India Private Limited: Sedan Cab Service for Corporate Employees Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and professional Sedan Cab Service for Corporate Employees in Pune, ensuring smooth and comfortable daily travel for staff working in IT parks, corporate offices, and industrial hubs. Our fleet of well-maintained sedan cars offers a perfect blend of comfort, safety, and efficiency for regular employee commute, airport transfers, and inter-office travel. With experienced chauffeurs, flexible rental plans, and timely service, we deliver a hassle-free transportation experience that supports productivity and employee convenience. Pune Corporate Cars India Private Limited ensures dependable and premium sedan cab service for corporate employees across Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
{
"name": "Corporate Sedan Hire Pune",
"description": "Corporate Sedan Hire Pune provides premium sedan vehicles for corporate employees, executives, and client transportation. The service ensures comfortable seating, professional drivers, GPS tracking, and timely pickups for office commutes, business meetings, and intercity travel, offering companies a reliable and efficient transportation solution."
},
{
"name": "Sedan Employee Transport Pune",
"description": "Sedan Employee Transport Pune delivers dedicated sedan services for daily employee commuting. With structured routes, multi-shift support, trained drivers, and well-maintained vehicles, the service ensures safe, punctual, and comfortable travel for office staff and IT park employees across Pune."
},
{
"name": "Office Sedan Cab Pune",
"description": "Office Sedan Cab Pune provides professional sedan-based cab services for office employees and corporate clients. The service focuses on reliable pickups and drops, smooth routing, and well-maintained vehicles, ensuring comfort, safety, and timely arrivals for daily office commutes."
},
{
"name": "Business Sedan Taxi Pune",
"description": "Business Sedan Taxi Pune offers premium sedan taxis for corporate travel, executive meetings, and client visits. With trained drivers, GPS-enabled vehicles, and flexible booking options, the service guarantees professional, comfortable, and efficient transportation for business travelers across Pune."
},
{
"name": "Sedan Pickup Drop Pune",
"description": "Sedan Pickup Drop Pune specializes in safe and reliable sedan-based pickup and drop services for employees. The service features fixed routes, punctual schedules, and trained chauffeurs, providing seamless transportation for staff commuting to offices, IT parks, and corporate hubs."
},
{
"name": "Corporate Car Sedan Pune",
"description": "Corporate Car Sedan Pune offers dedicated sedan services for corporate fleets, employee commuting, and client transportation. With well-maintained vehicles, professional drivers, and GPS tracking, the service ensures safe, punctual, and comfortable rides for executives and staff across Pune."
},
{
"name": "Outstation Sedan Cab Pune",
"description": "Outstation Sedan Cab Pune provides comfortable and safe long-distance travel with sedans for corporate trips, client visits, and intercity travel. The service includes trained drivers, GPS-enabled vehicles, and well-planned routes, ensuring efficient and hassle-free outstation commuting."
},
{
"name": "Best Sedan Fleet Pune",
"description": "Best Sedan Fleet Pune delivers top-quality sedan vehicles for corporate, executive, and employee transportation. The fleet is maintained to premium standards with professional drivers, structured routes, and multi-shift support, ensuring reliable, safe, and comfortable travel for businesses and organizations."
},
{
"name": "Monthly Sedan Cab Pune",
"description": "Monthly Sedan Cab Pune offers long-term sedan rental solutions for corporate employees and office staff. The service provides fixed monthly plans, dedicated drivers, and structured commuting schedules, ensuring consistent, safe, and comfortable transportation for large teams across Pune."
},
{
"name": "Affordable Sedan Taxi Pune",
"description": "Affordable Sedan Taxi Pune provides budget-friendly sedan transportation solutions without compromising on quality or safety. Ideal for daily office commutes, employee pickups, and corporate travel, the service ensures punctual, well-maintained vehicles and professional drivers at competitive rates."
},
{
"name": "Sedan Chauffeur Service Pune",
"description": "Sedan Chauffeur Service Pune offers professional driver services with premium sedans for executives, managers, and VIP clients. The service focuses on comfort, discretion, safety, and timely pickups for corporate travel, airport transfers, and intercity trips across Pune."
},
{
"name": "IT Employee Sedan Cab Pune",
"description": "IT Employee Sedan Cab Pune specializes in providing sedan transportation for IT park employees and tech company staff. With trained drivers, GPS-enabled vehicles, and structured routes, the service ensures timely, comfortable, and safe daily commutes for IT professionals across Pune."
},
{
"name": "Staff Sedan Commute Pune",
"description": "Staff Sedan Commute Pune delivers reliable sedan-based commuting services for office and industrial staff. The service includes multi-shift support, professional drivers, and route optimization to ensure safe, punctual, and efficient daily travel for employees."
},
{
"name": "Company Sedan Rental Pune",
"description": "Company Sedan Rental Pune provides dedicated sedans for corporate employee transportation, client visits, and business travel. The service offers well-maintained vehicles, professional drivers, GPS tracking, and structured commuting schedules for a seamless corporate travel experience."
},
{
"name": "Executive Sedan Car Pune",
"description": "Executive Sedan Car Pune offers high-end sedan vehicles with chauffeur services for corporate executives, VIP clients, and managers. The service ensures luxury, comfort, punctuality, and safety for office commutes, business meetings, and airport transfers across Pune."
}
],

"tableData": [
["Corporate Sedan Hire Pune", "Sedan Employee Transport Pune"],
["Office Sedan Cab Pune", "Business Sedan Taxi Pune"],
["Sedan Pickup Drop Pune", "Corporate Car Sedan Pune"],
["Outstation Sedan Cab Pune", "Best Sedan Fleet Pune"],
["Monthly Sedan Cab Pune", "Affordable Sedan Taxi Pune"],
["Sedan Chauffeur Service Pune", "IT Employee Sedan Cab Pune"],
["Staff Sedan Commute Pune", "Company Sedan Rental Pune"],
["Executive Sedan Car Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Sedan Cab Service for Corporate Employees Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable sedan cab services for corporate employees in Pune, ensuring comfortable and punctual daily commutes."
  },
  {
    "WhyChooseheading": "Comfortable & Spacious Sedans",
    "WhyChoosedescription": "Our fleet of well-maintained sedans offers ample space, modern amenities, and a smooth ride, ideal for corporate travel."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs",
    "WhyChoosedescription": "Our experienced and courteous drivers ensure safe, disciplined, and timely transportation for employees and executives."
  },
  {
    "WhyChooseheading": "Flexible Corporate Travel Plans",
    "WhyChoosedescription": "We offer customized rental packages including hourly, daily, and monthly options, tailored to meet corporate commuting needs."
  },
  {
    "WhyChooseheading": "Punctual & Reliable Service",
    "WhyChoosedescription": "We prioritize timely pickups and drops, ensuring employees reach their workplaces on schedule every day."
  },
  {
    "WhyChooseheading": "24/7 Corporate Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for scheduling changes, emergencies, and route adjustments to ensure smooth corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Sanitized Vehicles",
    "WhyChoosedescription": "All sedans are regularly sanitized, serviced, and equipped with safety features to provide a secure and hygienic ride."
  },
  {
    "WhyChooseheading": "Easy Booking & Efficient Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination for employee commutes."
  }
]





























  }

const faqData = [
  {
    question: 'Do you provide sedan cab services for corporate employees in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional sedan cab services for corporate employees across Pune.',
  },
  {
    question: 'What types of sedan vehicles are available for corporate travel?',
    answer: 'We offer premium sedans including Toyota Etios, Honda City, Maruti Ciaz, and similar vehicles for comfortable employee travel.',
  },
  {
    question: 'How can companies book sedan cab services in Pune?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'Do you provide customized transport plans for corporate employees?',
    answer: 'Yes, we offer tailored sedan cab services based on employee strength, routes, and shift timings.',
  },
  {
    question: 'Are chauffeurs provided with the sedan cab service?',
    answer: 'Absolutely. All sedans come with trained and professional chauffeurs ensuring a safe and punctual commute.',
  },
  {
    question: 'Can companies avail monthly or long-term contracts for sedan cab services?',
    answer: 'Yes, we provide flexible monthly, quarterly, and annual contracts for corporate clients.',
  },
  {
    question: 'Do you provide airport transfers using sedan cabs?',
    answer: 'Yes, our sedan cabs are available for timely airport pickups and drops for employees and VIP clients.',
  },
  {
    question: 'What safety measures are followed for sedan cab services?',
    answer: 'All sedans are GPS-enabled, sanitized regularly, and driven by verified and trained chauffeurs.',
  },
  {
    question: 'What payment options are available for sedan cab services?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide corporate invoicing for business clients.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Harshad Patil',
    feedback: 'The sedan cab service for our employees in Pune is excellent. Punctual, professional, and comfortable rides.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Snehal Kulkarni',
    feedback: 'Highly reliable corporate sedan cab service. Pune Corporate Cars India Private Limited manages our daily commute efficiently.',
    rating: 5,
  },
];
























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sedan Cab Service for Corporate Employees Pune",
  "image": "https://www.punecorporatecars.com/assets/images/sedan-cab-corporate-pune.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited provides reliable sedan cab services for corporate employees in Pune, including office pickup and drop, monthly commutes, chauffeur-driven sedans, and outstation travel. Ensure safe, comfortable, and timely travel for your employees with our corporate sedan fleet.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "5300", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1600", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/sedan-cab-service-corporate-pune"
  }
};

  return (
    <div>

<Helmet>
  <title>Sedan Cab Service for Corporate Employees Pune | Corporate Sedan Fleet | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited provides reliable sedan cab services for corporate employees in Pune, including office pickup and drop, monthly commutes, chauffeur-driven sedans, and outstation travel. Ensure safe, comfortable, and timely travel for your employees with our corporate sedan fleet."
  />

  <meta
    name="keywords"
    content="Corporate Sedan Hire Pune, Sedan Employee Transport Pune, Office Sedan Cab Pune, Business Sedan Taxi Pune, Sedan Pickup Drop Pune, Corporate Car Sedan Pune, Outstation Sedan Cab Pune, Best Sedan Fleet Pune, Monthly Sedan Cab Pune, Affordable Sedan Taxi Pune, Sedan Chauffeur Service Pune, IT Employee Sedan Cab Pune, Staff Sedan Commute Pune, Company Sedan Rental Pune, Executive Sedan Car Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/37.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sedancabservicweforcorporateemployees;